module.exports = __webpack_public_path__ + "static/img/volume-mute.54fae82c.svg";